"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireDefault(require("react"));

var _chunk5423f15f = require("./chunk-5423f15f.js");

var _MultiSelectOption = _interopRequireDefault(require("./MultiSelectOption.js"));

require("./chunk-76875e58.js");

require("./chunk-f2932d1d.js");

require("prop-types");

require("./chunk-8219403d.js");

require("./chunk-eb19ede6.js");

require("react-dom");

require("./chunk-5ef88ed1.js");

require("styled-components");

require("classnames");

require("./CheckboxIndicator.js");

require("./CFontIcon.js");

require("./layout.js");

require("./chunk-b15f6972.js");

require("./chunk-6104512b.js");

require("./chunk-cb015231.js");

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultiSelectMenuList = function MultiSelectMenuList(props) {
  var commonProps = ["cx", "clearValue", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "setValue", "selectProps", "theme"].reduce(function (sumProps, propKey) {
    return sumProps[propKey] = props[propKey], sumProps;
  }, {});
  return _react.default.createElement(_chunk5423f15f.a.MenuList, props, props.options.map(function (option) {
    return _react.default.createElement(_MultiSelectOption.default, (0, _chunkB2edacfb.g)({
      key: option.value,
      option: option
    }, commonProps));
  }));
};

MultiSelectMenuList.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MultiSelectMenuList"
};
var _default = MultiSelectMenuList;
exports.default = _default;
MultiSelectMenuList.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MultiSelectMenuList"
};